import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Space, Divider } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { login } from '../api';
import { useAuth } from '../context/AuthContext';

const { Title, Text, Paragraph } = Typography;

export default function Login() {
  const { loginUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const onFinish = async (values) => {
    setLoading(true); setError('');
    try {
      const { data } = await login(values);
      if (data.success && data.token && data.user) {
        loginUser(data.token, data.user);
      } else {
        setError(data.message || 'Login failed: server response missing token');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to connect to server');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 40%, #1e40af 70%, #0f172a 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      {/* Background pattern */}
      <div style={{
        position:'fixed', inset:0, opacity:0.04,
        backgroundImage:'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize:'40px 40px',
        pointerEvents:'none',
      }} />

      {/* Logo */}
      <div style={{ marginBottom: 32, textAlign: 'center' }}>
        <div style={{ fontSize: 48, fontWeight: 900, fontFamily: 'Georgia, serif', lineHeight: 1, marginBottom: 6 }}>
          <span style={{ position:'relative' }}>
            <span style={{ position:'absolute', top:-8, left:7, width:9, height:9, borderRadius:'50%', background:'#2E8B7A', display:'inline-block' }} />
            <span style={{ color:'#C41E3A' }}>i</span>
          </span>
          <span style={{ color:'#C41E3A' }}>d</span>
          <span style={{ color:'#5B7FE8' }}>en</span>
          <span style={{ color:'#E0E0E0' }}>tium</span>
          <sup style={{ fontSize:14, color:'rgba(255,255,255,0.4)', fontWeight:400, verticalAlign:'super' }}>®</sup>
        </div>
        <Text style={{ color:'rgba(255,255,255,0.55)', fontStyle:'italic', fontSize:13 }}>
          Creating identities for all
        </Text>
      </div>

      {/* Login card */}
      <Card
        style={{
          width: '100%', maxWidth: 420, borderRadius: 16,
          boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
          border: 'none',
        }}
        styles={{ body: { padding: '36px 40px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14,
            background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
          }}>
            <SafetyOutlined style={{ fontSize: 24, color: '#fff' }} />
          </div>
          <Title level={4} style={{ margin: 0, color: '#1e293b' }}>RFID Delegate Management System</Title>
          <Text type="secondary" style={{ fontSize: 12 }}>Sign in to your account</Text>
        </div>

        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 20, borderRadius: 8 }} />}

        <Form layout="vertical" onFinish={onFinish} size="large" requiredMark={false}>
          <Form.Item name="username" label="Username" rules={[{ required: true, message: 'Enter username' }]}>
            <Input prefix={<UserOutlined style={{ color: '#1B2B8C' }} />} placeholder="Enter your username" autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Enter password' }]}>
            <Input.Password prefix={<LockOutlined style={{ color: '#1B2B8C' }} />} placeholder="Enter your password" autoComplete="current-password" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary" htmlType="submit" block loading={loading}
              style={{ height: 44, borderRadius: 8, fontSize: 15, fontWeight: 600, background: 'linear-gradient(90deg, #2563eb, #1d4ed8)', border: 'none' }}
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>

        <Divider style={{ margin: '24px 0 16px' }} />
        <div style={{ textAlign: 'center' }}>
          <Text type="secondary" style={{ fontSize: 11 }}>
            Identium Tech Solutions Private Limited<br />
            Plot No. 5, Sant Nagar, East of Kailash, New Delhi - 110065<br />
            Ph: 011-47147839 &nbsp;|&nbsp; info@identium.in
          </Text>
        </div>
      </Card>

      <Text style={{ color: 'rgba(255,255,255,0.35)', fontSize: 11, marginTop: 24 }}>
        © {new Date().getFullYear()} Identium Tech Solutions Pvt Ltd. All rights reserved.
      </Text>
    </div>
  );
}
